/**
 * Add a value to a selection, or remove it when it's already there, always
 * returning a NEW set so callers keep the previous one immutable for React
 * state updates.
 *
 * Every multi-select filter on the schedule screens (by stage, by crew
 * function) does exactly this, so the behaviour lives here once rather than
 * being re-derived per filter.
 */
export function toggleInSet<T>(selected: ReadonlySet<T>, value: T): Set<T> {
  const next = new Set(selected);
  if (next.has(value)) next.delete(value);
  else next.add(value);
  return next;
}
